module.exports = __webpack_public_path__ + "static/media/calm_slightly-sad.f9bd73ab.svg";